import { apiGet, apiPost, apiPut, apiDelete } from './api'
import type { Submittal, SubmittalCreate, SubmittalUpdate, SubmittalReview, SubmittalReviewCreate } from '../types'

function buildQuery(filters: Record<string, string | undefined>): string {
  const parts: string[] = []
  for (const [key, val] of Object.entries(filters)) {
    if (val) parts.push(`${key}=${encodeURIComponent(val)}`)
  }
  return parts.length > 0 ? `?${parts.join('&')}` : ''
}

export const submittalApi = {
  getAll(filters: { projectId?: string; status?: string; type?: string } = {}): Promise<Submittal[]> {
    return apiGet<Submittal[]>(`/submittals${buildQuery(filters)}`)
  },

  getByProject(projectId: string, filters: { status?: string; type?: string } = {}): Promise<Submittal[]> {
    return apiGet<Submittal[]>(`/submittals/project/${projectId}${buildQuery(filters)}`)
  },

  getById(id: string): Promise<Submittal & { reviews: SubmittalReview[] }> {
    return apiGet(`/submittals/${id}`)
  },

  create(data: SubmittalCreate): Promise<Submittal> {
    return apiPost<Submittal>('/submittals', data)
  },

  update(id: string, data: SubmittalUpdate): Promise<Submittal> {
    return apiPut<Submittal>(`/submittals/${id}`, data)
  },

  delete(id: string): Promise<void> {
    return apiDelete(`/submittals/${id}`)
  },

  addReview(submittalId: string, data: SubmittalReviewCreate): Promise<SubmittalReview> {
    return apiPost<SubmittalReview>(`/submittals/${submittalId}/reviews`, data)
  },

  getReviews(submittalId: string): Promise<SubmittalReview[]> {
    return apiGet<SubmittalReview[]>(`/submittals/${submittalId}/reviews`)
  },
}
